import { render, staticRenderFns } from "./ToReceiveOrders.vue?vue&type=template&id=4c785a36"
import script from "./ToReceiveOrders.vue?vue&type=script&lang=js"
export * from "./ToReceiveOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports